import "core-js/modules/es.function.name.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementBlock as _createElementBlock, Transition as _Transition } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_AsideOrderSummary = _resolveComponent("AsideOrderSummary");

  var _component_el_aside = _resolveComponent("el-aside");

  var _component_router_view = _resolveComponent("router-view");

  var _component_el_main = _resolveComponent("el-main");

  var _component_el_container = _resolveComponent("el-container");

  return _openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(function () {
      return [_ctx.isInBooking ? (_openBlock(), _createBlock(_component_el_aside, {
        key: 0
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_AsideOrderSummary)];
        }),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_el_main, {
        style: {
          "padding-top": "0px",
          "padding-bottom": "0px"
        }
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_router_view, null, {
            default: _withCtx(function (_ref) {
              var Component = _ref.Component,
                  route = _ref.route;
              return [_createVNode(_Transition, {
                name: "el-fade-in-linear",
                mode: "out-in"
              }, {
                default: _withCtx(function () {
                  return [(_openBlock(), _createElementBlock("div", {
                    style: {
                      "height": "100%"
                    },
                    key: route.name
                  }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))]))];
                }),
                _: 2
              }, 1024)];
            }),
            _: 1
          })];
        }),
        _: 1
      })];
    }),
    _: 1
  });
}